import Description from "../../components/common/Description";
import { hcsMessage } from "../../components/common/json-data/hcsMessageData";
import Grid from "@mui/material/Grid";
import ApiTest from "../../components/common/ApiTest";
import React from "react";
import { postHcsMessage } from "../../components/common/constants";
import { Box } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import MiniDrawer from "../../components/navBar/Sidenav";
function HcsMessage() {
  return (
    <div style={{ display: "flex" }}>
      <MiniDrawer />
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Description bodyDesc={hcsMessage[0]} />
          </Grid>
          <Grid item xs={6}>
            <ApiTest apidata={postHcsMessage} />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default HcsMessage;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));
